module.exports = __webpack_public_path__ + "img/txw.bed99f64.png";